import React from "react";
var __jsx = React.createElement;
import { Dialog, TextField } from '@material-ui/core';
import { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import useGetBlockData from 'components/common/RichTextEditor/hooks/useGetBlockData';
import { GradientButton } from 'components/common/material-ui/custom-components';
import useSiteConfig from 'libs/common/hooks/useSiteConfig';
import { ButtonContainer, CloseButton, Description, FieldContainer, Title } from './Recipe.style';

var _manageToolLink = function manageToolLink(siteId) {
  return "https://www.aufeminin.com/reloaded/manage/recipe/recipe#/".concat(siteId, "/list");
};

var Recipe = function Recipe(_ref) {
  var editorState = _ref.editorState,
      blockKey = _ref.blockKey,
      entityKey = _ref.entityKey,
      removeBlock = _ref.removeBlock,
      updateBlockData = _ref.updateBlockData,
      updateEntity = _ref.updateEntity;

  var _useState = useState(''),
      recipeId = _useState[0],
      setRecipeId = _useState[1];

  var _useState2 = useState(false),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useSiteConfig = useSiteConfig(),
      id = _useSiteConfig.id;

  var _useGetBlockData = useGetBlockData(editorState, blockKey, entityKey),
      blockData = _useGetBlockData.blockData,
      entityData = _useGetBlockData.entityData;

  useEffect(function () {
    setIsOpen(blockData.openModal);
    setRecipeId(entityData.recipeId);
  }, [blockData, entityData]);
  var handleModalClose = useCallback(function () {
    if (recipeId === undefined) {
      removeBlock(blockKey);
      return;
    }

    updateBlockData(blockKey, {
      openModal: false
    });
  }, [recipeId, updateBlockData, blockKey, removeBlock]);
  var handleConfirm = useCallback(function () {
    updateEntity(entityKey, {
      recipeId: recipeId
    });
    updateBlockData(blockKey, {
      openModal: false
    });
  }, [blockKey, recipeId, entityKey, updateBlockData, updateEntity]);
  var handleRecipeDataChange = useCallback(function (event) {
    setRecipeId(event.target.value);
  }, []);
  return __jsx(Dialog, {
    open: isOpen,
    onClose: handleModalClose,
    maxWidth: "xl"
  }, __jsx(CloseButton, {
    onClick: handleModalClose
  }), __jsx(FormattedMessage, {
    id: "recipe-modal.title",
    tagName: Title
  }), __jsx(FormattedMessage, {
    id: "recipe-modal.description",
    tagName: Description,
    values: {
      // eslint-disable-next-line react/display-name
      manageToolLink: function manageToolLink(chunks) {
        return __jsx("a", {
          target: "_blank",
          rel: "noreferrer",
          href: _manageToolLink(id)
        }, chunks);
      }
    }
  }), __jsx(FieldContainer, null, __jsx(TextField, {
    "data-testid": "recipe-input-field",
    id: "recipe-input-field",
    variant: "outlined",
    label: __jsx(FormattedMessage, {
      id: "recipe-modal.recipeIdField"
    }),
    type: "text",
    fullWidth: true,
    value: recipeId,
    onChange: handleRecipeDataChange,
    multiline: false
  })), __jsx(ButtonContainer, null, __jsx(GradientButton, {
    disabled: !recipeId,
    onClick: handleConfirm
  }, __jsx(FormattedMessage, {
    id: "recipe-modal.confirm"
  }))));
};

export default Recipe;